<template>
  <div class="faq-bloc">
    <div class="faq-bloc-header">
      <h2>{{category.name}}</h2>
    </div>
    <div class="faq-bloc-body">
      <table class="mytable">
        <thead>
          <tr>
            <th>{{$resx('FaqItemTableHeader1Text')}}</th>
            <th>{{$resx('FaqItemTableHeader2Text')}}</th>
            <th>{{$resx('FaqItemTableHeader3Text')}}</th>
            <th>{{$resx('FaqItemTableHeader4Text')}}</th>
            <th>{{$resx('FaqItemTableHeader5Text')}}</th>
          </tr>
        </thead>
        <tbody v-show="!isSaving">
          <tr v-for="(item, index) in modelCopy.items" :key="item.id" :class="{inactive : !item.isValid}">
            <td>{{item.name}}<input type="hidden" :value="item.id" /></td>
            <td>
              <span v-if="!editMode && item.onSite===null">?</span>
              <i v-if="!editMode && item.onSite!==null" class='material-icons'>{{getCheckStateClass(item.onSite)}}</i>
              <select v-if="editMode" v-model="item.onSite" v-on:change="updateDistance(item)">
                <option v-bind:value="null">?</option>
                <option v-bind:value="true">{{$resx('OnSiteText')}}</option>
                <option v-bind:value="false">{{$resx('NotOnSiteText')}}</option>
              </select>
            </td>
            <td>
              <span v-if="!editMode && item.onSite===false && item.distance!==null ">{{item.distance}} km</span>
              <input v-if="editMode && item.onSite===false" type="number" min="0" max="200" v-model.number="item.distance" />
            </td>
            <td>
              <span v-if="!editMode && item.isFree===null">?</span>
              <i v-if="!editMode && item.isFree!==null" class='material-icons'>{{getCheckStateClass(item.isFree)}}</i>
              <select v-if="editMode" v-model="item.isFree">
                <option v-bind:value="null">?</option>
                <option v-bind:value="true">{{$resx('FreeText')}}</option>
                <option v-bind:value="false">{{$resx('NotFreeText')}}</option>
              </select>
            </td>
            <td>
              <i v-if="!editMode && item.highSeasonOnly!=null" class='material-icons'>{{getCheckStateClass(item.highSeasonOnly)}}</i>
              <select v-if="editMode" :name="'model['+index+'].HighSeasonOnly'" v-model="item.highSeasonOnly">
                <option v-bind:value="true">{{$resx('YesText')}}</option>
                <option v-bind:value="false">{{$resx('NoText')}}</option>
              </select>
            </td>
          </tr>
        </tbody>
        <tfoot v-show="isSaving">
          <tr>
            <td colspan="5" class="text-center">
              <i class="loading material-icons">cached</i>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div class="faq-bloc-footer">
      <button v-show="!editMode" class="btn btn-secondary" @click="editMode=true">{{$resx('EditText')}}</button>
      <button v-show="editMode" class="btn btn-secondary" @click="editMode=false">{{$resx('CancelText')}}</button>
      <button v-show="editMode" style="margin-left:.5em" class="btn btn-primary" @click="save"  :disabled="isSaving">{{$resx('SaveText')}}</button>
    </div>
  </div>
</template>
<script>
import FaqItem from '../../models/faq/faqItem'
import faqServices from '../../services/faqServices'
export default {
  props: {
    category: null
  },
  data () {
    return {
      isSaving: false,
      editMode: false,
      modelCopy: null
    }
  },
  computed: {
    // camping actuellement sélectionné
    currentCampingId () {
      return this.$store.getters['partner/currentCampingId']
    }
  },
  watch: {
    editMode: function (val) {
      if (val) {
        this.modelCopy = this.copyFullObject(this.category)
      }
    }
  },
  methods:
  {
    // Copie de l'objet référence dans une autre variable
    copyFullObject: function (source) {
      var newObj = {
        id: source.id,
        name: source.name,
        items: []
      }
      source.items.forEach(function (element) {
        newObj.items.push(new FaqItem(element))
      })
      return newObj
    },

    // distance a null si sur site
    updateDistance: function (item) {
      if (item.onSite !== false) {
        item.distance = null
      }
    },

    // retourne l'icone pour indiquer le statut d'un item
    getCheckStateClass: function (value) {
      if (value === null) {
        return 'fa-question'
      } else {
        return value ? 'check' : 'close'
      }
    },

    // sauvegarde des éléments
    save () {
      const self = this
      this.isSaving = true
      faqServices.saveFaqCategory(this.currentCampingId, this.modelCopy)
        .then(response => {
          // signaler l'update au parent
          self.$emit('update-category', this.copyFullObject(this.modelCopy))
          self.isSaving = false
          self.editMode = false
          const message = self.$resx('FaqSavedText')
          self.$store.commit('app/showSnack', { type: 'success', message: message })
        })
        .catch(error => {
          self.isSaving = false
          self.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
        })
    }
  },
  created: function () {
    this.modelCopy = this.copyFullObject(this.category)
  }
}
</script>
